// Generated by tools/export_contract_assets.py from contract/ -- do not edit.
// Locale: en. 761 messages.

/** A plural entry: English selects `one` at exactly one and `other` otherwise. */
export interface PluralForms {
  one: string;
  other: string;
}

export const STRINGS = {
  "app.name": "MeetFolks",
  "app.tagline": "The AI note-taker for in-person meetings",
  "app.reload": "Reload",
  "app.reset_hint": "Add ",
  "app.reset_code": "?reset=app",
  "app.reset_tail": " to the address if it keeps happening.",
  "app.not_found": "Not found",
  "app.not_found_hint": "There is no page at this address. ",
  "app.back_to_app": "Back to the app",
  "app.screen_broke": "We couldn’t open this screen.",
  "app.screen_broke_fault": "This screen broke",
  "app.something_broke": "Something broke",
  "common.try_again": "Try again",
  "common.retry": "Retry",
  "common.close": "Close",
  "common.done": "Done",
  "common.or": "or",
  "common.privacy": "Privacy",
  "common.terms": "Terms",
  "common.support": "Support",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.untitled_meeting": "Meeting {when}",
  "common.technical_details": "Technical details",
  "common.why": "Why?",
  "nav.home": "Home",
  "nav.meetings": "Recent meetings",
  "nav.account": "Account",
  "nav.settings": "Settings",
  "home.welcome": "Welcome!",
  "home.welcome_named": "Welcome, {name}!",
  "home.account": "Account",
  "home.settings": "Settings",
  "home.checking_account": "Checking your account…",
  "home.account_paused": "We couldn't check your account, so meetings are paused. Please try again.",
  "home.start_conversation": "Start a meeting",
  "home.start_subtitle": "Start a meeting and invite others.",
  "home.blocked_no_time": "Buy credits",
  "home.blocked_no_time_subtitle": "You're out of credits. Buy some to start a new meeting.",
  "home.blocked_owed_subtitle": "You owe {credits} credits. Buy credits to start a new meeting.",
  "home.blocked_paused": "Meetings paused",
  "home.blocked_paused_subtitle": "This account can't start new meetings right now.",
  "home.blocked_other_meeting": "One meeting at a time",
  "home.blocked_other_meeting_subtitle": "Your other meeting is still running.",
  "home.blocked_choose_plan": "Choose a plan",
  "home.blocked_out": "Out of credits",
  "home.error_start_no_time": "Buy credits to start a new meeting.",
  "home.error_start_paused": "This account can't start new meetings right now.",
  "home.error_start_other_meeting": "Your other meeting is still running. End it before you start a new one.",
  "home.other_meeting_elsewhere": "A meeting is still running on another of your devices.",
  "home.other_meeting_here": "A meeting is still running on this device.",
  "home.device_in_meeting": "This device is still in another meeting.",
  "home.end_it": "End it",
  "home.leave_it": "Leave it",
  "home.end_confirm": "End your other meeting for everyone in it? Its notes will be ready as usual.",
  "home.ending_other_meeting": "Ending your other meeting…",
  "home.ending_other_meeting_slow": "Still ending your other meeting. This can take a few minutes.",
  "home.leaving_other_meeting": "Leaving your other meeting…",
  "home.error_end": "We couldn’t end your other meeting. Check your connection and try again.",
  "home.error_end_not_yours": "Only the person who started that meeting can end it.",
  "home.error_end_limited": {
    one: "You’ve tried to end meetings too many times. Try again in 1 minute.",
    other: "You’ve tried to end meetings too many times. Try again in {count} minutes.",
  },
  "home.error_end_slow": "Your other meeting is taking a while to end. Try again in a few minutes.",
  "home.error_leave": "We couldn’t leave your other meeting. Check your connection and try again.",
  "home.join_existing": "Join a meeting",
  "home.join_nearby": "Join nearby",
  "home.type_code": "Type code",
  "home.join_by_link": "Join by link",
  "home.recent_sessions": "Recent meetings",
  "home.see_all": "See all",
  "home.new_meeting": "New meeting",
  "home.starting": "Starting…",
  "home.listening": "Listening",
  "home.search_stopped": "Search stopped",
  "home.ask_host_nearby": "Ask the host to turn on nearby joining.",
  "home.listen_again": "Listen again",
  "home.enter_code": "Enter code",
  "home.enter_session_code": "Enter meeting code",
  "home.ask_for_code": "Ask whoever started the meeting for the {count}-character code.",
  "home.meeting_code": "Meeting code",
  "home.joining": "Joining…",
  "home.join": "Join",
  "home.code_hint": "Joins automatically when the code is complete.",
  "home.error_account_start": "Finish setting up your account on this device before starting a meeting.",
  "home.error_account_join": "Finish setting up your account on this device before joining.",
  "home.signin_to_start": "Sign in to start or join a meeting.",
  "home.error_start": "We couldn’t start the meeting. Check your connection and try again.",
  "home.error_start_limited": {
    one: "You’ve started too many meetings from this device. Try again in 1 minute.",
    other: "You’ve started too many meetings from this device. Try again in {count} minutes.",
  },
  "home.joining_code": "Joining {code}…",
  "home.error_join": "We couldn’t join that meeting. Check the code and try again.",
  "home.error_join_limited": {
    one: "You’ve tried to join too many times from this device. Try again in 1 minute.",
    other: "You’ve tried to join too many times from this device. Try again in {count} minutes.",
  },
  "home.code_length": "A code is {count} characters.",
  "home.looking_nearby": "Looking for a nearby meeting…",
  "home.no_meeting": "No meeting found. Ask the host for the meeting code.",
  "home.error_chirp": "Couldn’t look for nearby meetings. Enter the meeting code instead.",
  "home.error_mic": "We couldn’t use your microphone. Allow microphone access for this site and try again.",
  "home.error_mic_native": "We couldn’t use your microphone. Allow MeetFolks to use the microphone in Settings, then try again.",
  "signin.or_sign_in": "Sign in",
  "signin.promise": "Private. Accurate. SuperFast",
  "signin.email_label": "Email me a sign-in link",
  "signin.email_placeholder": "you@example.com",
  "signin.send_link": "Send the link",
  "signin.continue_google": "Continue with Google",
  "signin.continue_apple": "Continue with Apple",
  "signin.unavailable": "Sign-in is currently unavailable. Please try again later.",
  "signin.offline": "Unable to connect. Check your internet connection and try again.",
  "signin.error_email": "That does not look like an email address.",
  "signin.sent": "{detail}. It works once and expires in ten minutes — open it in this browser to sign in here.",
  "signin.sent_browser": "{detail}. It works once and expires in ten minutes — for now the link opens in your browser.",
  "signin.sent_app": "{detail}. It works once and expires in ten minutes — open it on this device to sign in.",
  "signin.code_prompt": "Enter the sign-in code for this account.",
  "signin.code_label": "Sign-in code",
  "signin.code_placeholder": "Sign-in code",
  "signin.code_submit": "Sign in",
  "signin.code_wrong": "That code is not right. Check it and try again.",
  "signin.outcome_signed_in": "Signed in as {email}.",
  "signin.outcome_failed": "That sign-in did not complete. Try again.",
  "signin.outcome_unlinked": "Set up, but this device could not be linked to your account.",
  "signin.outcome_link_unknown": "the device link could not be checked",
  "signin.outcome_link_error": "Signed in, but this device was not linked: {message}",
  "signin.outcome_unreachable": "could not reach the account service",
  "consent.title": "How MeetFolks uses AI",
  "consent.intro": "To write your meeting notes, MeetFolks uses these AI services:",
  "consent.stt": "Microsoft turns your meeting's audio into a transcript.",
  "consent.llm": "OpenAI's GPT model writes your summaries and notes and answers Ask AI.",
  "consent.how": "These services are reached through OpenRouter. They receive your meeting's audio, the transcript with who said what, and your Ask AI questions. They use it only to give you those results, don't keep your meeting's content afterwards, and never use it to train AI models. OpenRouter keeps basic request details, such as size and timing.",
  "consent.voice_profile": "Your voice profile never leaves your phone.",
  "consent.voice_profile_device": "Your voice profile never leaves your device.",
  "consent.agree_terms": "By tapping Agree and continue, you agree to this and to our {privacy} and {terms}.",
  "consent.agree_terms_click": "By clicking Agree and continue, you agree to this and to our {privacy} and {terms}.",
  "consent.privacy_link": "Privacy Notice",
  "consent.terms_link": "Terms",
  "consent.agree": "Agree and continue",
  "consent.agree_failed": "We couldn't save your answer. Check your connection and try again.",
  "consent.what_shared": "What is shared",
  "consent.how_used": "How it is used",
  "consent.processing": "How processing works",
  "consent.shared_detail": "Meeting audio, the transcript with who said what, and your Ask AI questions.",
  "consent.used_detail": "These services use it only to give you results, don't keep your meeting's content afterwards, and never use it to train AI models. OpenRouter keeps basic request details, such as size and timing.",
  "consent.routing_detail": "These services are reached through OpenRouter.",
  "account.heading": "Account",
  "account.link_error": "This device's account link could not be checked, so meetings are blocked.",
  "account.device_link_pending": "Linking this device to your account…",
  "account.device_linked": "This device is linked to your account.",
  "account.since": "since {date}",
  "account.sign_out": "Sign out",
  "account.sign_out_confirm": "Your voice profile on this device will be deleted. You’ll need to set up your voice again. Past meetings stay on your account.",
  "account.sign_out_meeting_busy": "Finish or leave your meeting, and let it finish saving, before you sign out.",
  "account.your_voice": "Your voice",
  "account.voice_profile": "Voice profile",
  "account.last_set_up": "Last set up {date}",
  "account.rerecord": "Set up voice again",
  "account.no_voice": "No voice profile in this browser. Set up your voice here to join meetings.",
  "account.no_voice_device": "No voice profile on this device. Set up your voice here to join meetings.",
  "account.your_privacy": "Your privacy",
  "account.delete_row": "Delete account",
  "account.delete_heading": "Delete your account?",
  "account.delete_lede": "We'll delete your account and sign you out everywhere.",
  "account.delete_solo": "Meetings where you were the only person are deleted.",
  "account.delete_shared": "In meetings with other people, your audio is deleted and you're shown as an unnamed speaker. The others keep their notes.",
  "account.delete_credits": "Unused credits are lost. Payment records are kept.",
  "account.delete_plan_web": "Your plan is cancelled straight away. You won't be charged again.",
  "account.delete_plan_app_store": "Your plan is paid through the App Store. Deleting your account doesn't stop it, so cancel it there first or you'll keep being charged.",
  "account.delete_plan_google_play": "Your plan is paid through Google Play. Deleting your account doesn't stop it, so cancel it there first or you'll keep being charged.",
  "account.delete_plan_open_app_store": "Cancel in the App Store",
  "account.delete_plan_open_google_play": "Cancel in Google Play",
  "account.delete_cannot_undo": "This can't be undone.",
  "account.delete_confirm": "Delete account",
  "account.delete_working": "Deleting your account…",
  "account.delete_busy": "Finish or leave your meeting, and let it finish saving, before you delete your account.",
  "account.delete_failed": "We couldn't delete your account. Try again in a moment.",
  "account.deleted": "Your account has been deleted.",
  "account.session_ended": "You've been signed out. Sign in to continue.",
  "account.meeting_data": "Meeting data",
  "account.what_kept": "What is kept?",
  "account.kept_detail": "We keep a record of your payments for 7 years for tax, with no name or email attached.",
  "account.delete_meetings": "Meetings",
  "account.delete_balance": "Credits",
  "delete_account.heading": "Delete your account",
  "delete_account.lede": "Enter the email you use for MeetFolks. We'll send you a link to confirm. You don't need to sign in.",
  "delete_account.email_label": "Your email",
  "delete_account.send": "Send the link",
  "delete_account.sending": "Sending…",
  "delete_account.sent": "If there's an account for {email}, we've sent a link to delete it. The link works once and expires in ten minutes.",
  "delete_account.send_failed": "We couldn't send the link. Try again in a moment.",
  "delete_account.confirm_heading": "Delete your account?",
  "delete_account.store_plan_note": "If you pay for MeetFolks through the App Store or Google Play, deleting your account doesn't stop that. Cancel it there too.",
  "delete_account.confirm": "Delete account",
  "delete_account.link_expired": "This link has expired or has already been used.",
  "delete_account.request_new": "Send a new link",
  "delete_account.done": "Your account has been deleted.",
  "email_unsubscribe.heading": "Turn off meeting emails?",
  "email_unsubscribe.lede": "Sign-in emails and push settings won’t change.",
  "email_unsubscribe.confirm": "Turn off meeting emails",
  "email_unsubscribe.confirming": "Turning them off…",
  "email_unsubscribe.confirmed": "Meeting emails are off. Turn them on again in Settings.",
  "email_unsubscribe.bad_link": "That link doesn't work any more. You can turn meeting emails off in Settings, in the app or on the web.",
  "billing.heading": "Credits",
  "billing.left": "{credits} credits left",
  "billing.none_left": "No credits left",
  "billing.hint": "A meeting you start uses a credit a minute. Joining someone else's meeting is free.",
  "billing.paused": "This account can't start new meetings right now.",
  "billing.add_time": "Buy credits",
  "billing.loading": "Loading your credits…",
  "billing.load_error": "We couldn't load your credits.",
  "billing.history": "History",
  "billing.history_empty": "No credit activity yet.",
  "billing.history_title": "Credits history",
  "billing.tx_free_grant": "Free trial credits",
  "billing.tx_topup": "Credits added",
  "billing.tx_meeting": "Meeting",
  "billing.tx_writeoff": "Not charged",
  "billing.tx_writeoff_detail": "One meeting never leaves you owing more than 360 credits",
  "billing.tx_dispute": "Payment disputed",
  "billing.tx_dispute_reversal": "Dispute resolved",
  "billing.tx_adjustment": "Adjustment",
  "billing.tx_plan_grant": "Monthly credits",
  "billing.tx_plan_expiry": "Unused monthly credits",
  "billing.tx_trial_expiry": "Unused trial credits",
  "billing.added": "+{credits} credits",
  "billing.used": "−{credits} credits",
  "billing.top_up_label": "Buy credits",
  "billing.top_up_heading": "Buy credits",
  "billing.top_up_hint": "1 credit = 1 minute of a meeting you start.",
  "billing.web_note": "The web sells more credits for the same money.",
  "billing.web_note_link": "Top up there instead",
  "billing.pack_time": "{credits} credits",
  "billing.pack_hours": "About {hours} hours",
  "billing.pack_best_value": "Best value",
  "billing.continuing": "Opening payment…",
  "billing.unavailable": "Buying credits isn't available right now.",
  "billing.error_checkout": "We couldn't open the payment page. Try again in a moment.",
  "billing.returned_paid": "Payment received. Your credits will show here in a moment.",
  "billing.returned_pending": "We're confirming your payment. Your credits will show here once it's through.",
  "billing.returned_added": "Credits added.",
  "billing.returned_unpaid": "The payment didn't go through.",
  "billing.purchase_adding": "Adding your credits…",
  "billing.purchase_added": "{credits} credits added.",
  "billing.purchase_pending": "We'll add your credits when the payment goes through.",
  "billing.purchase_delayed": "Payment received. We'll add your credits shortly.",
  "billing.purchase_not_added": "We couldn't add credits for this payment. Write to hello@meetfolks.app and we'll put it right.",
  "billing.carry_over": "Extra credits carry over.",
  "billing.pack_after": "You'll have {credits} credits",
  "billing.run_out_continues": "Your meeting continues if credits run out.",
  "billing.buy": "Buy {credits} credits for {price}",
  "billing.short": "{credits} credits due",
  "billing.pack_still_short": "Still {credits} credits due",
  "billing.pack_none_left": "No credits left to start a meeting",
  "plans.basic": "Basic",
  "plans.plus": "Plus",
  "plans.pro": "Pro",
  "plans.none": "No plan",
  "plans.price_month": "{price} a month",
  "plans.credits_month_hours": "{credits} credits a month · About {hours} hours",
  "plans.ask_ai_per_meeting": {
    one: "{count} Ask AI question per meeting",
    other: "{count} Ask AI questions per meeting",
  },
  "plans.ask_ai_unlimited": "Unlimited Ask AI questions*",
  "plans.fair_use_link": "Fair use",
  "plans.current": "Your plan",
  "plans.choose": "Choose {plan}",
  "plans.upgrade": "Upgrade to {plan}",
  "plans.switch": "Switch to {plan}",
  "plans.ends": "Ends on {date}",
  "plans.switches_on": "Switches to {plan} on {date}",
  "plans.restore": "Restore purchases",
  "plans.restore_none": "No purchases to restore.",
  "plans.restore_failed": "We couldn't restore your purchases. Try again in a moment.",
  "plans.purchase_active": "Your {plan} plan is active.",
  "plans.purchase_confirming": "We're confirming your subscription.",
  "plans.purchase_failed": "We couldn't start your plan for this payment. Write to hello@meetfolks.app and we'll put it right.",
  "plans.change_failed": "We couldn't change your plan. Try again in a moment.",
  "plans.upgrade_confirm": "Upgrade to {plan}? You'll pay today, minus what's left of your current plan, and your new month starts today.",
  "plans.upgrade_confirm_amount": "Upgrade to {plan}? You'll pay {price} today, and your new month starts today.",
  "plans.renewal_note": "Plans renew monthly until cancelled.",
  "plans.label": "Plans",
  "plans.no_plan_continue": "Purchase a plan to continue meetings.",
  "plans.see": "See plans",
  "plans.trial": "Free trial",
  "plans.monthly_left": "{left} of {total} monthly credits left",
  "plans.trial_left": "{left} of {total} trial credits left",
  "plans.resets": "Resets on {date}",
  "plans.extra_credits": "{credits} extra credits",
  "plans.never_expire": "Never expire",
  "plans.usable_with_plan": "Usable with a plan",
  "plans.out": "Out of credits",
  "plans.keep": "Keep my plan",
  "plans.change": "Change plan",
  "plans.manage_billing": "Manage billing",
  "plans.manage_app_store": "Manage in App Store",
  "plans.manage_google_play": "Manage in Google Play",
  "plans.manage_web": "Manage on the web",
  "plans.running_low": "Running low",
  "plans.payment_failed_active": "Payment failed. Plan still active.",
  "plans.payment_failed_paused": "Payment failed. Plan paused.",
  "plans.update_payment": "Update payment details",
  "plans.notes_free": "Summaries and notes are free.",
  "plans.ask_ai_per_person": "Ask AI limits are per person.",
  "plans.credits_reset": "Monthly credits reset at renewal.",
  "plans.fair_use_short": "*Fair use",
  "plans.choose_none": "Choose a plan",
  "plans.compare": "Compare plans",
  "plans.locked_app_store": "Billed through the App Store. Change it there.",
  "plans.locked_google_play": "Billed through Google Play. Change it there.",
  "plans.locked_web": "Billed on the web. Change it there.",
  "plans.billed_web": "Billed on the web.",
  "plans.billed_google_play": "Billed through Google Play.",
  "plans.locked_payment": "Update your payment details to change plans.",
  "plans.unavailable": "Plans aren't available right now.",
  "enroll.rerecord_heading": "Re-record your voice",
  "enroll.new_heading": "Let’s set up your voice",
  "enroll.voice_setup_complete": "Your voice is set up",
  "enroll.ready": "You’re ready to join meetings in this browser.",
  "enroll.ready_device": "You’re ready to join meetings from this device.",
  "enroll.your_voice": "Your voice",
  "enroll.speaker": "Speaker",
  "enroll.takes": "Takes",
  "enroll.saved": "Saved",
  "enroll.on_this_device": "On this device",
  "enroll.your_name": "Your name",
  "enroll.your_name_placeholder": "e.g. Ravi",
  "enroll.name_hint": "Shown beside your speech in meeting notes.",
  "enroll.preview": "Preview",
  "enroll.speaker_placeholder": "Speaker",
  "enroll.name_preview": "Your name will appear beside your words in the meeting transcript.",
  "enroll.speaker_two": "Speaker 2",
  "enroll.other_answers": "Someone else answers from across the table.",
  "enroll.setup_steps": "Voice setup steps",
  "enroll.take_n": "Take {n}",
  "enroll.listening": "Listening",
  "enroll.live_badge": "Rec",
  "enroll.takes_ready": "Three takes captured",
  "enroll.read_aloud": "Read aloud",
  "enroll.speak_naturally": "Find a quiet place and speak normally.",
  "enroll.finish_go_home": "Go to Home",
  "enroll.continue": "Continue",
  "enroll.another_take": "Another take",
  "enroll.save_voice_profile": "Save voice profile",
  "enroll.finish_setup": "Finish setup",
  "enroll.listening_ellipsis": "Listening…",
  "enroll.starting": "Starting…",
  "enroll.preparing_model": "Getting the voice model ready…",
  "enroll.building_profile": "Building your voice profile…",
  "enroll.start_take": "Start Take {n}",
  "enroll.about_voice_setup": "About voice setup",
  "enroll.about_p1": "Read three short passages so we can recognise your voice in meetings you join from here.",
  "enroll.about_p2": "Your voice profile stays in this browser on this device. Set up your voice again in any other browser or on any other device.",
  "enroll.about_p2_device": "Your voice profile stays on this device. Set up your voice again on any other device.",
  "enroll.about_p3": "Setting up your voice again updates your voice profile. Your past meetings stay unchanged.",
  "enroll.find_quiet": "Find a quiet space",
  "enroll.briefing": "Read three short passages so this device can recognise your voice.",
  "enroll.set_up_my_voice": "Set up my voice",
  "enroll.privacy_note": "Your voice profile stays in this browser on this device.",
  "enroll.privacy_note_device": "Your voice profile stays on this device.",
  "enroll.error_name_needed": "A name is needed — it is how other people see you in the summary.",
  "enroll.voice_profile_updated": "Voice profile updated.",
  "enroll.error_save": "{flow} failed: {message}",
  "enroll.flow_rerecord": "Re-record",
  "enroll.flow_setup": "Setup",
  "enroll.status_listening_line": "Listening — read the line aloud.",
  "enroll.status_warning": "Listening. {warning}",
  "enroll.status_checking_take": "Checking that take…",
  "enroll.status_short": "Only {seconds} seconds of speech in that take — at least {min} seconds is needed. Try again, a little closer.",
  "enroll.status_different": "These takes sound different. Try again in a quiet place, using the same microphone for all three.",
  "enroll.status_captured": "Take {count} captured — {seconds} seconds of speech.",
  "enroll.status_mic_problem": "Microphone problem: {message}",
  "enroll.error_no_identity": "This device has no identity to re-record against. Set it up first.",
  "enroll.script_1": "Read verse out loud for pleasure. Rice is often served in round bowls.",
  "enroll.script_2": "The juice of lemons makes fine punch. Four hours of steady work faced us.",
  "enroll.script_3": "The salt breeze came across from the sea. Smoky fires lack flame and heat.",
  "session.setting_up": "Setting up the meeting…",
  "session.meeting_in_progress": "Meeting in progress",
  "session.meeting_ended": "Meeting ended",
  "session.hold_title": "On hold",
  "session.back_in_meeting_title": "Back in the meeting",
  "session.return_to_meeting": "Return to meeting",
  "session.on_hold": "On hold. This device is out of the meeting while you are away, and the rest of it carries on.",
  "session.call_name": "MeetFolks meeting",
  "session.call_unavailable": "This device can't show the meeting as a call, so an incoming call may pause your part of the meeting. The rest of the meeting carries on.",
  "session.notification_title": "MeetFolks meeting · {time}",
  "session.notification_leave": "Leave",
  "session.notification_channel": "Meeting in progress",
  "session.preparing_notes": "Preparing your notes…",
  "session.email_when_ready": "You can close the app now.",
  "session.share_code": "Share to invite others.",
  "session.this_device": "this device",
  "session.this_device_name": "This device",
  "session.in_meeting": "In the meeting",
  "session.capture_pause": "This device missed {duration} of the meeting, so that part wasn't captured. Keep this page open during the meeting.",
  "session.capture_pause_native": "This device missed {duration} of the meeting, so that part wasn't captured. Keep the app in the meeting.",
  "session.let_nearby_join": "Let nearby people join",
  "session.waiting_end": "Waiting for the meeting to end…",
  "session.saving_part": "Saving your audio… Keep this page open.",
  "session.get_summary": "Get the summary",
  "session.end_for_everyone": "End the meeting for everyone",
  "session.leave_meeting": "Leave the meeting",
  "session.discard": "Discard my part of this meeting",
  "session.end_hint_creator": "Ending the meeting ends it for everyone. We'll email you the notes when they're ready.",
  "session.end_hint_guest": "Others can carry on.",
  "session.blocker": "You’re still in the meeting. Leave the meeting to get your notes, or discard your part of it. Closing this page now would lose the part that hasn't been saved yet.",
  "session.blocker_host": "You’re still in the meeting. End the meeting for everyone to get your notes. Closing this page now would lose the part that hasn't been saved yet.",
  "session.session_code": "Meeting code",
  "session.code_placeholder": "—",
  "session.processing_aria": "Processing",
  "session.participants_aria": "Participants",
  "session.upload_health_aria": "Upload health",
  "session.capture_pause_aria": "Capture pause notice",
  "session.upload_uploaded": "All audio saved",
  "session.upload_catching_up": "Uploading…",
  "session.upload_reconnecting": "Waiting for a connection…",
  "session.upload_refused": "Audio upload stopped",
  "session.waiting_for": "Waiting for {who} to end the meeting…",
  "session.waiting_for_others": "Waiting for the others to end the meeting…",
  "session.still_in_one": "{name} is still in the meeting",
  "session.still_in_many": "The other participants are still in the meeting",
  "session.still_in_another": "Another participant is still in the meeting",
  "session.transcript_after": "{who}. The transcript will be here after they end it.",
  "session.gap_background": "This device missed {duration} of the meeting while the app was in the background. Everything else is saved.",
  "session.gap_resumed": "You’re back in the meeting. This device missed {duration}, which wasn’t captured. The rest of your meeting is saved.",
  "session.dropped_out": "This device dropped out of the meeting. Reload the page to rejoin it.",
  "session.screen_awake": "This browser cannot keep the screen awake. Locking the screen may take this device out of the meeting; keep this page open.",
  "session.voice_lost": "The meeting continues, but we can no longer recognise your voice. Reload the page to rejoin the meeting.",
  "session.mic_stopped": "The microphone stopped for {duration}. You’re back in the meeting.",
  "session.scoring_error": "We couldn’t recognise your voice in part of the meeting. The meeting continues.",
  "session.signed_out": "This device has left the meeting. Set up your voice again, then sign in.",
  "session.host_ended": "The host ended the meeting. Saving your part of it…",
  "session.ended_on_your_other_device": "You ended this meeting on another of your devices. Saving your part of it…",
  "session.meeting_has_ended": "The meeting has ended.",
  "session.voice_unmatched": "The meeting continues, but we can no longer match your voice to your name.",
  "session.slow_connection": "Your connection is slow. The meeting continues while we catch up.",
  "session.ended_elsewhere": "The meeting was ended on another device.",
  "session.saving_part_short": "Saving your audio…",
  "session.words_unnamed": "Some of your words may appear without your name in the transcript.",
  "session.finishing_part": "Finishing your part of the meeting…",
  "session.watermark_failed": "We couldn’t finish saving your part of the meeting. Please try leaving again. Anything already saved is kept.",
  "session.ending_for_everyone": "Ending the meeting for everyone…",
  "session.telling_others": "Telling the others you are done…",
  "session.waiting_others_finish": "Waiting for the other participants to finish…",
  "session.last_words_unnamed": "Your last few words may appear without your name in the transcript.",
  "session.check_notes_failed": "We couldn’t check on your notes. Press again to keep waiting.",
  "session.leave_failed": "We couldn’t finish leaving this meeting. Please try again.",
  "session.summary_pending_notice": "The transcript is here; the summary is still being written and will appear when you come back.",
  "session.still_processing": "Still preparing your notes. You can check Past meetings later.",
  "session.discard_confirm": "Delete your part of this meeting and leave it?\n\nThe audio this device already sent, and anything transcribed from it, is removed. There will be no summary for this device. This cannot be undone.",
  "session.deleting_part": "Deleting your part of this meeting…",
  "session.deleted_and_left": "Your part of the meeting was deleted and you left it.",
  "session.left_nothing_saved": "You left the meeting. Nothing of yours was saved.",
  "session.delete_failed": "We couldn’t delete your part of the meeting. Check your connection and try again.",
  "session.chirp_unavailable": "Nearby joining is unavailable. Share the meeting code instead.",
  "session.chirp_on": "Nearby joining on. Anyone nearby can join and read the transcript. Turn it off once everyone has joined.",
  "session.chirp_off": "Nearby joining is off.",
  "session.identity_block": "This device's account link needs fixing before you can join a meeting. Open Account to fix it.",
  "session.not_set_up": "This device is not set up yet.",
  "session.identity_detail": "Setting up your voice again gives this device a new identity. Its three takes and a sign-in reconnect it to your account.",
  "session.nearby_details": "About nearby joining",
  "session.nearby_access": "Anyone nearby can join while nearby joining is on, and everyone who joins gets the transcript. Turn it off once everyone has joined.",
  "session.nearby_on": "Nearby joining on",
  "result.heading": "Meeting notes",
  "result.rename": "Rename meeting",
  "result.meeting_name": "Meeting name",
  "result.rename_failed": "Couldn’t rename this meeting. Try again.",
  "result.rename_speaker": "Rename speaker",
  "result.speaker_name": "Speaker name",
  "result.rename_speaker_failed": "Couldn’t rename this speaker. Try again.",
  "result.failed_creator": "We couldn't prepare your meeting notes. Please try again.",
  "result.failed_guest": "We couldn't prepare your meeting notes. The person who started the meeting can try again.",
  "result.try_again": "Try again",
  "result.waiting_long": "This is taking longer than usual. You can check Past meetings later.",
  "result.preparing": "Preparing your notes…",
  "result.leave_screen": "You can leave this screen and check Past meetings later.",
  "result.check_again": "Check again",
  "result.retry_unavailable": "Trying again isn't available right now. Please check back later.",
  "result.retry_failed": "We couldn't try again. Check your connection and retry.",
  "result.load_no_access": "These notes aren't available to this account. They're only for people who took part in the meeting.",
  "result.load_deleted": "This meeting went quiet for too long, so it was closed and its audio was deleted. There are no notes for it.",
  "result.load_failed": "We couldn't load your meeting notes. Check your connection and try again.",
  "result.details": "Meeting details",
  "result.date": "Date",
  "result.duration": "Duration",
  "result.topics": "Topics",
  "result.partial": "Partial transcript",
  "result.partial_note": "Some parts of this meeting may be missing from the transcript.",
  "result.capture_gap_named": "{name}'s device was out of the meeting for {duration} here",
  "result.capture_gap_anonymous": "A device was out of the meeting for {duration} here",
  "result.someone_else": "Someone else",
  "result.overlap": "{names} spoke at the same time",
  "result.summary": "Meeting summary",
  "result.writing_summary": "Writing your summary…",
  "result.not_available": "Not available",
  "result.summary_failed": "We couldn't write a summary for this meeting. Your full transcript is below.",
  "result.writing_the_summary": "Writing the summary…",
  "result.next_steps": "Next steps",
  "result.due": "(due {due})",
  "result.at": " · at {time}",
  "result.spoke_for": "Spoke for {duration}",
  "result.no_summary_participant": "No summary is available for this participant.",
  "result.follow_ups": {
    one: "{count} follow-up",
    other: "{count} follow-ups",
  },
  "result.transcript": "Transcript",
  "result.transcript_entries_aria": "Transcript entries",
  "result.export": "Export",
  "result.expand_transcript": "Show",
  "result.collapse_transcript": "Hide",
  "result.export_title_fallback": "Meeting transcript",
  "result.export_date": "Date: {date}",
  "result.export_duration": "Duration: {duration}",
  "result.export_summary_heading": "## Meeting Summary",
  "result.export_next_steps_heading": "## Next Steps & Action Items",
  "result.export_transcript_heading": "## Transcript",
  "result.export_due": " (Due: {due})",
  "result.processing_aria": "Processing",
  "result.failed_aria": "Processing failed",
  "result.partial_aria": "Partial transcript notice",
  "result.tabs_aria": "Meeting notes",
  "result.tab_quick": "Quick",
  "result.tab_detailed": "Detailed",
  "result.time_range": "{start}–{end}",
  "result.jump_to_moment": "Jump to {time}",
  "result.jump_to_moment_aria": "Jump to {time} in the transcript",
  "result.summary_failed_tab": "We couldn't write a summary for this meeting. The full transcript is in the Transcript tab.",
  "result.quick_empty": "There's no summary for this meeting. The full transcript is in the Transcript tab.",
  "result.notes_style": "Notes style",
  "result.notes_styles_aria": "Notes styles",
  "result.notes_style_written_aria": "{style}, written",
  "result.notes_pick": "Choose a style. Notes are shared with the meeting.",
  "result.notes_unavailable": "Notes in a style aren't available here.",
  "result.notes_loading": "Loading the notes…",
  "result.notes_load_failed": "We couldn't load the notes. Check your connection and try again.",
  "result.notes_writing": "Writing notes…",
  "result.notes_writing_note": "You can come back later.",
  "result.notes_taking_long": "This is taking longer than usual.",
  "result.notes_updating": "Updating your notes…",
  "result.notes_failed": "We couldn't write these notes.",
  "result.notes_update_failed": "We couldn't update these notes. These are the ones written before.",
  "result.notes_out_of_date": "New meeting results are available.",
  "result.notes_update": "Update notes",
  "result.notes_rate_limited": "You've asked for a lot of notes today. Try again tomorrow.",
  "result.notes_view_aria": "How to show the notes",
  "result.notes_view_list": "List",
  "result.notes_view_map": "Mind map",
  "result.notes_map_aria": "Mind map of the notes",
  "result.notes_state_expanded": "Expanded",
  "result.notes_state_collapsed": "Collapsed",
  "result.export_notes_heading": "## {style}",
  "result.actions_heading": "Actions",
  "result.actions_done": "{done} / {total} done",
  "result.action_owner": "Owner: {name}",
  "result.action_due": "Due {due}",
  "result.action_due_today": "Due today",
  "result.action_due_tomorrow": "Due tomorrow",
  "result.action_due_on": "Due {date}",
  "result.action_overdue": "Overdue · {date}",
  "result.action_was_due": "Was due {date}",
  "result.action_mark_done": "Mark done: {text}",
  "result.action_done_by": "Done by {name}",
  "result.action_save_failed": "We couldn't save that tick. Try again.",
  "result.highlights_aria": "Key points",
  "result.quote_aria": "{name}, in their own words",
  "result.quote_expand": "Show the whole quote",
  "result.speakers_heading": "Speakers",
  "result.speakers_count": {
    one: "{count} Participant",
    other: "{count} Participants",
  },
  "result.search_label": "Search the transcript",
  "result.search_placeholder": "Search the transcript",
  "result.clear_search": "Clear search",
  "result.search_matches": {
    one: "{count} match",
    other: "{count} matches",
  },
  "result.search_empty": "Nothing in this meeting matches “{query}”.",
  "result.speakers_aria": "Show what one person said",
  "result.all_speakers": "Everyone",
  "result.chat_open": "Ask AI",
  "result.chat_open_aria": "Ask AI about this meeting",
  "result.chat_hide": "Hide",
  "result.chat_hide_aria": "Hide Ask AI",
  "result.chat_dialog_aria": "Ask AI about this meeting.",
  "result.chat_title": "Ask AI",
  "result.chat_private": "Only you can see this chat.",
  "result.chat_loading": "Loading your chat…",
  "result.chat_empty": "Ask me anything about this meeting, or tap a suggestion below.",
  "result.chat_suggestions_aria": "Suggested questions",
  "result.chat_suggestion_commitments": "What did I commit to?",
  "result.chat_suggestion_open": "What's still open?",
  "result.chat_suggestion_follow_up": "Draft a follow-up",
  "result.chat_input_label": "Your question",
  "result.chat_input_placeholder": "Ask about this meeting…",
  "result.chat_count": "{count} / {max}",
  "result.chat_too_long": "A question can be up to {max} characters.",
  "result.chat_send": "Send",
  "result.chat_you": "You",
  "result.chat_ai": "Ask AI",
  "result.chat_writing": "Reading the meeting…",
  "result.chat_not_from_meeting": "Not from the meeting",
  "result.chat_cite": "{name} · Jump to {time}",
  "result.chat_cite_aria": "Jump to {time} in the transcript, where {name} spoke",
  "result.chat_out_of_scope": "I can only help with this meeting: what was said, decided or planned, and the things it mentioned. Try asking about that.",
  "result.chat_rate_limited_soon": "You're asking questions quickly. Wait a minute and try again.",
  "result.chat_rate_limited_today": "You've asked a lot of questions today. Try again tomorrow.",
  "result.chat_resting": "You’ve reached today’s Ask AI limit. Try again after the daily reset.",
  "result.chat_busy": "Another answer is still being written. Wait for it to finish, then try again.",
  "result.chat_full": "This chat is full.",
  "result.chat_new": "Start a new chat",
  "result.chat_new_confirm": "Start a new chat? This one will be deleted.",
  "result.chat_error": "We couldn't answer that.",
  "result.chat_offline": "You're offline. Ask AI needs a connection.",
  "result.chat_load_failed": "We couldn't load your chat. Check your connection and try again.",
  "result.chat_too_long_meeting": "This meeting is too long for Ask AI.",
  "result.chat_delete": "Delete chat",
  "result.chat_delete_confirm": "Delete this chat? This can't be undone.",
  "result.chat_delete_failed": "We couldn't delete the chat. Try again.",
  "result.chat_limit_meeting": "You've used your {max} questions for this meeting.",
  "result.chat_limit_next": "{used} questions used. {plan} includes {count} per meeting.",
  "result.chat_limit_next_unlimited": "{used} questions used. {plan} has no limit*",
  "result.chat_fair_use_month": "You've reached this month's fair-use limit for Ask AI. It resets on {date}.",
  "result.notes_history": "Processing history",
  "result.notes_history_detail": "These notes were written before the latest meeting results.",
  "notes.style.meeting": "Meeting notes",
  "notes.style.client_call": "Client call",
  "notes.style.interview": "Interview",
  "notes.style.lecture": "Lecture notes",
  "notes.style.workshop": "Workshop",
  "notes.style.one_to_one": "One-to-one",
  "sessions.heading": "Recent Meetings",
  "sessions.lede": "Every meeting your devices were part of, newest first. Open one to read its transcript.",
  "sessions.loading": "Loading your meetings…",
  "sessions.empty": "No meetings yet.",
  "sessions.empty_hint": "Meetings you start or join will appear here.",
  "sessions.error": "We couldn’t load your meetings. Check your connection and try again.",
  "sessions.signin_expired": "Your sign-in has expired. Sign in again to see your meetings.",
  "sessions.page": "Page {page}",
  "sessions.page_of": "Page {page}/{total}",
  "sessions.loading_more": "Loading more meetings…",
  "sessions.all_loaded": "That’s every meeting.",
  "sessions.newer": "Newer",
  "sessions.older": "Older",
  "past_session.no_transcript": "No transcript",
  "past_session.in_progress": "In progress",
  "past_session.failed": "Failed",
  "past_session.untitled": "Untitled meeting",
  "past_session.under_a_minute": "under a minute",
  "past_session.minutes": "{minutes} min",
  "past_session.hours_minutes": "{hours} h {minutes} min",
  "past_session.hours": "{hours} h",
  "past_session.speakers": {
    one: "{count} speaker",
    other: "{count} speakers",
  },
  "settings.heading": "Settings",
  "settings.lede": "Make MeetFolks feel like you.",
  "settings.appearance": "Appearance",
  "settings.appearance_hint": "Choose a theme. Your changes appear instantly.",
  "settings.live_preview": "Preview",
  "settings.start_conversation": "Start a conversation",
  "settings.project_checkin": "Project check-in",
  "settings.today": "Today",
  "settings.theme": "Theme",
  "settings.current_theme": "{name} is your current theme.",
  "settings.privacy": "Privacy",
  "settings.share_stats": "Share anonymous usage stats",
  "settings.share_stats_hint": "Help us improve the app. No meeting content is included.",
  "settings.share_stats_hint_device": "Help us improve the app. No meeting content is included.",
  "settings.gpc": "Global Privacy Control is on, so usage stats are off.",
  "settings.stats_ask_title": "Help improve MeetFolks?",
  "settings.stats_ask_body": "Share anonymous stats on how the app is used. Never your meeting's audio, words or notes. You can change this any time in Settings.",
  "settings.stats_ask_dont_share": "Don't share",
  "settings.stats_ask_share": "Share",
  "settings.notifications": "Notifications",
  "settings.email_meetings": "Meeting emails",
  "settings.email_meetings_hint": "Get an email when meeting notes are ready.",
  "settings.preview_aria": "Live theme preview",
  "settings.about": "About",
  "settings.version": "Version",
  "settings.build": "Build",
  "settings.core_version": "Core version",
  "settings.wire_version": "Wire version",
  "theme.original": "Original teal",
  "theme.espresso": "Buttercup & espresso",
  "theme.honey": "Honey & chocolate",
  "theme.sage": "Sage & honey",
  "theme.navy": "Navy & porcelain",
  "theme.terracotta": "Matte terracotta",
  "theme.aubergine": "Aubergine & lavender",
  "theme.rose": "Dusty rose & burgundy",
  "notify.channel": "Meeting notes",
  "notify.disable": "Don't notify me",
  "notify.enable": "Notify me when ready",
  "notify.on_hint": "Notifications on",
  "notify.off_hint": "Processing can outlast this screen. A notification means you can close the app and come back when it’s ready.",
  "ui.close": "Close",
  "ui.session_code": "Meeting code",
  "ui.take_captured": "Take {n} captured, {seconds} seconds of speech",
  "ui.take_captured_no_seconds": "Take {n} captured",
  "ui.take_not_recorded": "Take {n} not recorded",
  "ui.character_of": "Character {n} of {total}",
  "wrap.close": "Telling the other participants the meeting has ended",
  "wrap.score": "Saving your part of the meeting",
  "wrap.upload": "Sending the last audio",
  "wrap.watermark": "Finishing your part of the meeting",
  "wrap.report": "Saying you are done",
  "wrap.waiting": "Waiting for the others to end the meeting",
  "wrap.merge": "Preparing your meeting notes",
  "finalise.retrying": "Still finishing your part of the meeting…",
  "finalise.exhausted": "We couldn’t finish ending this meeting. You can try again.",
  "caveat.unknown_device": "unknown device",
  "caveat.placement_degraded": "Placement for one device is approximate near the pauses in its part of the meeting ({device}). Cross-device ordering there may be off.",
  "caveat.arrival_order": "{stretches} from one device ({device}) are shown in arrival order, not placed on the shared timeline.",
  "caveat.stretches": {
    one: "{count} stretch",
    other: "{count} stretches",
  },
  "caveat.some_stretches": "Some stretches",
  "caveat.device_out": "One device ({device}) was out of the meeting -- speech during those stretches is missing from its claim.",
  "caveat.device_out_for": "One device ({device}) was out of the meeting for {duration} in total -- speech during those stretches is missing from its claim.",
  "caveat.unknown": "Reduced-accuracy result: an unrecognized placement caveat is present ({caveat}).",
  "audio.paused": "Meetings are paused on this service right now.",
  "audio.warning": "This browser could not reach the server's settings, so it will not send audio for transcription — what was said near this device may be missing from the transcript. Who spoke is unaffected. Reload the page to try again.",
  "audio.warning_device": "This device could not reach MeetFolks, so what was said near it may be missing from the transcript. Who spoke is unaffected. Close and reopen the app to try again.",
  "state.processing_label": "Preparing your notes",
  "state.default_disclosure": "Your voice profile stays in this browser on this device.",
  "state.default_disclosure_device": "Your voice profile stays on this device.",
  "state.disclosure": "Your voice profile stays in this browser on this device; {bits}.",
  "state.disclosure_device": "Your voice profile stays on this device; {bits}.",
  "state.audio_upload": "audio is uploaded and deleted after {window}",
  "state.no_audio": "no audio leaves this device",
  "state.third_party_transcribes": "a third party transcribes it",
  "state.third_party_summary": "a third-party service prepares your summary",
  "state.fault": "{what}: {message}",
  "duration.seconds": "{seconds} s",
  "duration.short_seconds": "{seconds}s",
  "duration.short_minutes_seconds": "{minutes}m {seconds}s",
  "duration.words_seconds": {
    one: "1 second",
    other: "{count} seconds",
  },
  "duration.words_minutes": {
    one: "1 minute",
    other: "{count} minutes",
  },
  "duration.words_one_minute_seconds": {
    one: "1 minute 1 second",
    other: "1 minute {count} seconds",
  },
  "duration.words_minutes_seconds": {
    one: "{minutes} minutes 1 second",
    other: "{minutes} minutes {count} seconds",
  },
  "boot.https": "This page needs HTTPS. Microphone access is blocked on plain HTTP, so open the https:// URL.",
  "boot.unsupported": "This browser can’t join meetings. Try an updated version of Safari, Chrome or Firefox.",
  "boot.getting_ready": "Getting ready…",
  "boot.getting_ready_percent": "Getting ready… {percent}%",
  "boot.load_failed": "We couldn’t get ready for your meeting. Check your connection and reload the page.",
  "boot.load_failed_retry": "We couldn’t get ready for your meeting. Check your connection and try again.",
  "boot.mount_missing": "index.html is missing its <main id=\"root\"> mount point",
  "model.getting_ready": "Getting ready…",
  "model.getting_ready_percent": "Getting ready… {percent}%",
  "model.size_note": "This needs a one-time download of about 84 MB.",
  "model.failed": "We couldn’t get ready for your meeting. Check your connection and try again.",
  "model.offline": "You’re offline. Getting ready needs a one-time download, so connect and try again.",
  "welcome.intro_tagline": "Experience the most seamless in‑person meeting note‑taking",
  "welcome.intro_continue": "Continue",
  "welcome.step_start": "Emma starts a meeting",
  "welcome.step_join": "James holds his phone near",
  "welcome.step_join_again": "Sophie does the same",
  "welcome.step_hear": "Each phone hears its owner clearly",
  "welcome.step_notes": "Notes with every name",
  "welcome.step_start_a11y": "Emma taps Start a meeting. Her phone opens the meeting to the table.",
  "welcome.step_join_a11y": "James taps Join nearby and brings his phone close to Emma’s. The phones find each other and he’s in.",
  "welcome.step_join_again_a11y": "Sophie joins the same way. Everyone at the table is in the meeting on their own phone.",
  "welcome.step_hear_a11y": "As each person talks, their own phone picks them up from close by, so every voice is clear and marked as theirs.",
  "welcome.step_notes_a11y": "Emma ends the meeting. Everyone who joined gets the notes, with every line credited to the right person.",
  "welcome.next": "Next step",
  "welcome.back": "Previous step",
  "welcome.get_started": "Get started",
  "welcome.play_again": "Play again",
  "welcome.joined": "Joined",
  "welcome.in_meeting": "In the meeting",
  "welcome.meeting_minutes": "Meeting · {count} min",
  "welcome.meeting_ended": "Meeting ended · {count} min",
  "welcome.person_1": "Emma",
  "welcome.person_2": "James",
  "welcome.person_3": "Sophie",
  "welcome.notes_title": "Weekly planning",
  "welcome.notes_ready": "Notes ready · for all {count}",
  "welcome.notes_line_1": "Ship the pilot on Friday.",
  "welcome.notes_line_2": "Brief the client on Thursday.",
  "welcome.notes_line_3": "The budget stays as it is.",
} as const satisfies Record<string, string | PluralForms>;

export type StringKey = keyof typeof STRINGS;

/**
 * Look up a message by key. A plural entry picks its form from `vars.count`.
 * `{name}` placeholders are filled from `vars`; an unknown name is left as-is
 * so a missing argument is visible rather than silently blank.
 */
export function t(key: StringKey, vars: Record<string, string | number> = {}): string {
  const entry = STRINGS[key];
  const template =
    typeof entry === "string" ? entry : entry[Number(vars.count) === 1 ? "one" : "other"];
  return template.replace(/\{(\w+)\}/g, (match, name: string) => {
    const value = vars[name];
    return value === undefined ? match : String(value);
  });
}
